interface EliteHeaderProps {
  regularFundCount: number
}

export default function EliteHeader({ regularFundCount }: EliteHeaderProps) {
  return (
    <div className='px-5 pb-5'>
      <div className='text-[22px] font-medium leading-[1]'>Regular to Direct Plan</div>
      <div className='text-base leading-[1] mt-3'>
        {regularFundCount} {regularFundCount === 1 ? 'fund' : 'funds'} lowering your returns
      </div>
      <div className='text-[13px] text-grey40 mt-4'>
        Regular funds have a higher expense ratio than Direct funds, which lowers your returns. With this plan, switch to Direct funds, tax-efficiently.
      </div>
    </div>
  )
}
